<template>
<div>
  {{label}}
  <v-layout row　align-center>
    <v-flex md3>
      <v-text-field
        v-model.number="year"
        suffix="年"
        type="number"
        @blur="updateYear"
        :error-messages="yearErrorMessage"
      />
    </v-flex>
    <v-flex md3>
      <v-select :items="months" v-model="month" suffix="月"/>
    </v-flex>
    <v-flex md3>
      <v-select :items="dates" v-model="date" suffix="日"/>
    </v-flex>
  </v-layout>
</div>
</template>
<script>
import { getMoment, validDateToUnixtime } from "@/utils/datetime";
const moment = getMoment();
export default {
  props: {
    upperLimmitOfYear: {
      type: Number,
      default: 2020
    },
    lowerLimmitOfYear: {
      type: Number,
      default: 1900
    },
    value: {
      // unixtime
      type: Number,
      default: -32400
    },
    label: {
      type: String,
      default: "生年月日"
    }
  },
  data() {
    return {
      yearError: { code: "no-error", message: "" }
    };
  },
  computed: {
    years() {
      return range(this.lowerLimmitOfYear, this.upperLimmitOfYear);
    },
    months() {
      return range(1, 12);
    },
    dates() {
      const nDays = moment([this.year, this.month - 1, this.date])
        .endOf("month")
        .date();
      return range(1, nDays);
    },
    year: {
      get() {
        const m = moment.unix(this.value);
        return m.year();
      },
      set(year) {
        if (moment([year, 0, 1]).isValid()) {
          this.updateValue({ year });
        }
      }
    },
    month: {
      get() {
        const m = moment.unix(this.value);
        return m.month() + 1;
      },
      set(month) {
        this.updateValue({ month });
      }
    },
    date: {
      get() {
        const m = moment.unix(this.value);
        return m.date();
      },
      set(date) {
        this.updateValue({ date });
      }
    },
    yearErrorMessage() {
      if (
        this.yearError &&
        "code" in this.yearError &&
        this.yearError.code != "no-error"
      ) {
        return this.yearError.message;
      } else {
        return "";
      }
    }
  },
  methods: {
    updateYear() {
      if (
        moment([this.year, 0, 1]).isValid() &&
        this.year <= this.upperLimmitOfYear &&
        this.year >= this.lowerLimmitOfYear
      ) {
        this.updateError({ code: "no-error", message: "" });
        this.updateValue({ year: this.year });
      } else {
        const error = {};
        error.code = "year-out-of-range";
        error.message =
          String(this.lowerLimmitOfYear) +
          "以上、" +
          String(this.upperLimmitOfYear) +
          "以下の半角数字を入力してください。";
        this.updateError(error);
      }
    },
    updateValue(change) {
      const { year, month, date } = this;
      const args = { year, month, date, ...change };
      this.$emit(
        "input",
        validDateToUnixtime([args.year, args.month - 1, args.date])
      );
    },
    updateError(error) {
      this.$emit("update:error", error);
      this.yearError = Object.assign({}, this.yearError, error);
    }
  }
};
function range(min, max) {
  const a = [];
  for (let i = min; i <= max; ++i) {
    a.push(i);
  }
  return a;
}
</script>
